const dict = {
  languageName: 'Polski',
  locale: 'pl',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'Motyw',
  'theme.light': 'Jasny',
  'theme.dark': 'Ciemny',
  'theme.system': 'Systemowy',
  'theme.sakura': 'Sakura',

  // generic
  email: 'E-mail',
  password: 'Hasło',
  ok: 'OK',
  cancel: 'Anuluj',
  retry: 'Ponów',
  copy: 'Kopiuj',
  empty: '(brak elementów)',
  loading: 'Ładowanie...',
  calculating: 'Obliczanie...',
  error: 'Błąd',

  'in_development': 'Ta strona jest w przygotowaniu.',

  // errors
  'error.not_found': 'nie znaleziono',
  'error.name_conflict': 'konflikt nazw',
  'error.bad_param': 'błędny parametr',
  'error.wrong_auth': 'błędna autoryzacja',
  'error.unauthorized': 'brak autoryzacji',
  'error.wrong_credentials': 'błędne dane logowania',
  'error.wrong_provider': 'błędny dostawca',
  'error.insufficient_privileges': 'niewystarczające uprawnienia',
  'error.not_empty': 'nie jest pusty',
  'error.limit_exceeded': 'przekroczono limit',
  'error.already_member': 'już jest członkiem',
  'error.not_finalized': 'nie sfinalizowano',
  'error.already_finalized': 'już sfinalizowano',
  'error.unexpected_patch': 'nieoczekiwana poprawka',
  'error.timeout': 'przekroczono limit czasu',
  'error.not_patch': 'nie jest poprawką',
  'error.not_supported': 'nieobsługiwane',
  'error.unexpected_error': 'nieoczekiwany błąd',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': 'Uwierzytelnianie',
  'auth.dialog.please_select': 'Wybierz dostawcę konta, aby się zalogować.',
  'auth.dialog.redirecting_to': (provider) => `Przekierowywanie do ${provider}...`,
  'auth.dialog.remember_me': 'Zapamiętaj mnie',
  'auth.dialog.log_in': 'Zaloguj się',
  'auth.dialog.back': 'Wstecz',
  'auth.dialog.progress_header': 'Uwierzytelnianie...',
  'auth.dialog.error.header': 'Błąd uwierzytelniania',
  'auth.dialog.error.auth_not_allowed': 'Użycie tych danych logowania do uwierzytelniania zostało zablokowane przez użytkownika. Użyj innych danych.',
  'auth.dialog.error.unknown': 'Nieprawidłowe parametry uwierzytelniania. Spróbuj ponownie.',
  'auth.dialog.error.back': 'Wróć',

  'user.profile': 'Profil',
  'user.logout': 'Wyloguj się',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'Nie znaleziono strony',
  'page_not_found.message': 'Ta strona nie istnieje.',
  'page_not_found.message2': 'Cóż, w pewnym sensie istnieje, ale nic tu nie ma. Oto możliwe przyczyny.',
  'page_not_found.items': [
    'Coś tu wcześniej było, ale zostało usunięte.',
    'Coś tu nadal jest, ale nie masz do tego dostępu.',
    'Albo ktoś po prostu pomylił się przy kopiowaniu i wklejaniu linku.',
  ],

  'home': 'Główna',
  'home.header.hint': 'Narzędzia chmurowe dla twórców indie',
  'home.description': 'Kavykhi.Cloud to platforma programistyczna dla gier indie. Wspieramy gry do pobrania i przeglądarkowe, wersje prywatne i publiczne, gałęzie, zespoły i wiele więcej.',
  'home.auth': 'Zaloguj się lub zarejestruj',
  'home.auth.hint': 'Utwórz nowe konto lub zaloguj się na istniejące',

  'projects': 'Projekty',
  'projects.hint': 'Projekty, nad którymi pracujesz',
  'projects.project': (project) => `Projekt: ${project}`,
  'projects.project.hint': 'projekt',
  'projects.no_projects': 'Nie masz jeszcze żadnych projektów.',
  'projects.new': 'Utwórz projekt',
  'projects.new_dialog.header': 'Nowy projekt',
  'projects.new_dialog.label': 'Nazwa projektu',
  'projects.new_dialog.ok': 'Utwórz projekt',
  'projects.store_page': 'Publiczna strona sklepu',
  'projects.description': 'Opis',
  'projects.branches': 'Gałęzie',
  'projects.versions': 'Wersje',
  'projects.packages': 'Pakiety',
  'projects.management': 'Ustawienia projektu',
  'projects.management.breadcrumb': 'Ustawienia',
  'projects.management.title': (projectTitle) => `${projectTitle} - ustawienia`,
  'projects.management.hint': 'ustawienia projektu',
  'projects.management.users': 'Członkowie zespołu',
  'projects.management.users.empty': 'Brak członków zespołu.',
  'projects.management.users.role.tester': 'Tester',
  'projects.management.users.role.developer': 'Deweloper',
  'projects.management.users.role.admin': 'Administrator',
  'projects.management.users.role.owner': 'Właściciel',
  'projects.management.users.role.starred': 'Wyróżniony',
  'projects.management.users.exile': 'Usuń z zespołu',
  'projects.management.users.exile.dialog.header': 'Usuń z zespołu',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>Czy na pewno chcesz usunąć użytkownika {userTitle} z projektu {projectTitle}?</>,
  'projects.management.users.exile.dialog.ok': 'Usuń z zespołu',
  'projects.management.invites.one_time_invite': 'Jednorazowy link zaproszenia',
  'projects.management.invites.one_time_invite.header': 'Jednorazowy link zaproszenia',
  'projects.management.invites.one_time_invite.message': 'Jednorazowy link zaproszenia:',
  'projects.management.invites.one_time_invite.note': 'Ważny przez 24 godziny, może być użyty raz.',
  'projects.management.invites.new_dialog.header': 'Link zaproszenia',
  'projects.management.invites.new_dialog.expires': 'Wygasa za:',
  'projects.management.invites.new_dialog.expires.indefinite': '(brak wygasania)',
  'projects.management.invites.new_dialog.approval.label': 'Użytkownik dołącza do projektu:',
  'projects.management.invites.new_dialog.approval.not_approved': 'po zatwierdzeniu przez admina',
  'projects.management.invites.new_dialog.approval.approved': 'natychmiast',
  'projects.management.invites.new_dialog.seats': 'Limit dołączeń:',
  'projects.management.invites.new_dialog.seats.no_limit': '(bez limitu)',
  'projects.management.invites.new_dialog.ok': 'Utwórz link zaproszenia',
  'projects.management.deploy_sites': 'Witryny wdrożeniowe',
  'projects.management.deploy_sites.empty': 'Nie dodano witryn wdrożeniowych.',
  'projects.management.deploy_sites.add': 'Dodaj witrynę wdrożeniową',
  'projects.management.deploy_sites.delete': 'Usuń',
  'projects.management.deploy_sites.delete_dialog.header': 'Usuń witrynę wdrożeniową',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>Czy na pewno chcesz usunąć witrynę wdrożeniową {provider} {site}?</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'Usuń witrynę wdrożeniową',
  'projects.management.public_access': 'Dostęp publiczny',
  'projects.management.public_access.enable': 'Włącz dostęp publiczny',
  'projects.management.public_access.enabled': <>Dostęp publiczny: <strong>dozwolony</strong></>,
  'projects.management.public_access.enabled.note': 'Nazwa i opis projektu są publiczne, podobnie jak wszelkie gałęzie oznaczone jako publiczne.',
  'projects.management.public_access.enable_dialog.header': 'Włącz dostęp publiczny',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>Czy na pewno chcesz zezwolić na publiczny dostęp do projektu {projectTitle}?<br /><br />Spowoduje to, że podstawowe informacje o projekcie będą dostępne bez uwierzytelniania. Musisz osobno włączyć dostęp publiczny dla każdej gałęzi, którą chcesz upublicznić.</>,
  'projects.management.public_access.enable_dialog.ok': 'Włącz dostęp publiczny',
  'projects.management.public_access.disable': 'Wyłącz dostęp publiczny',
  'projects.management.public_access.disabled': <>Dostęp publiczny: <strong>niedozwolony</strong></>,
  'projects.management.public_access.disabled.note': 'Projekt jest prywatny. Tylko członkowie zespołu projektu mają do niego dostęp.',
  'projects.management.public_access.disable_dialog.header': 'Wyłącz dostęp publiczny',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>Czy na pewno chcesz wyłączyć publiczny dostęp do projektu {projectTitle}?</>,
  'projects.management.public_access.disable_dialog.ok': 'Wyłącz dostęp publiczny',
  'projects.management.public_access.branches': 'Publiczne gałęzie',
  'projects.management.manage': 'Zarządzaj projektem',
  'projects.rename': 'Zmień nazwę projektu',
  'projects.rename_dialog.header': 'Zmień nazwę projektu',
  'projects.rename_dialog.label': 'Nazwa projektu:',
  'projects.rename_dialog.ok': 'Zmień nazwę',
  'projects.edit_description': 'Edytuj opis projektu',
  'projects.edit_description_dialog.header': 'Edytuj opis projektu',
  'projects.edit_description_dialog.label': 'Opis projektu:',
  'projects.edit_description_dialog.ok': 'Zapisz opis',
  'projects.leave': 'Opuść projekt',
  'projects.leave_dialog.header': 'Opuść projekt',
  'projects.leave_dialog.message': (projectTitle) => <>Czy na pewno chcesz opuścić projekt {projectTitle}?</>,
  'projects.leave_dialog.ok': 'Opuść projekt',
  'projects.delete': 'Usuń projekt',
  'projects.delete_dialog.header': 'Usuń projekt',
  'projects.delete_dialog.message': (projectTitle) => <>Czy na pewno chcesz usunąć projekt {projectTitle}?</>,
  'projects.delete_dialog.ok': 'Usuń projekt',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': 'gałąź',
  'branches.no_branches': 'Projekt nie ma jeszcze żadnych gałęzi',
  'branches.new': 'Utwórz gałąź',
  'branches.new_dialog.header': 'Nowa gałąź',
  'branches.new_dialog.label': 'Nazwa gałęzi',
  'branches.new_dialog.ok': 'Utwórz gałąź',
  'branches.current_version': (version) => <>Aktualna wersja: {version}</>,
  'branches.current_version.packages': 'Pakiety aktualnej wersji',
  'branches.no_current_version': 'Brak aktualnej wersji',
  'branches.publish_version.new': 'Opublikuj nową wersję',
  'branches.publish_version.existing': 'Opublikuj istniejącą wersję',
  'branches.version_history': 'Historia wersji',
  'branches.version_history.empty': 'Historia wersji tej gałęzi jest pusta.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>Aktualna wersja gałęzi jest przechowywana {quotaTime != null ? <>przez {quotaTime}</> : <>bezterminowo</>}. Poprzednie wersje są przechowywane maksymalnie przez {quotaNonCurrentTime}. Łącznie w gałęzi przechowywanych jest nie więcej niż {plural(quotaCount, <>{quotaCountText} wersja</>, <>{quotaCountText} wersji</>)}.</>,
  'branches.manage': 'Zarządzaj gałęzią',
  'branches.rename': 'Zmień nazwę gałęzi',
  'branches.rename_dialog.header': 'Zmień nazwę gałęzi',
  'branches.rename_dialog.label': 'Nazwa gałęzi:',
  'branches.rename_dialog.ok': 'Zmień nazwę',
  'branches.delete': 'Usuń gałąź',
  'branches.delete_dialog.header': 'Usuń gałąź',
  'branches.delete_dialog.message': (branchTitle) => <>Czy na pewno chcesz usunąć gałąź {branchTitle}?</>,
  'branches.delete_dialog.ok': 'Usuń gałąź',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'wersja',
  'versions.current': 'Aktualna',
  'versions.previous': 'Poprzednia',
  'versions.description': 'Opis',
  'versions.deploy_to_site.header': 'Publikuj w witrynie',
  'versions.deploy_to_site': 'Publikuj w witrynie',
  'versions.packages': 'Pakiety',
  'versions.branches': 'W gałęziach',
  'versions.branches.publish': 'Opublikuj w gałęzi',
  'versions.branches.empty': 'Ta wersja nie została opublikowana w żadnej gałęzi.',
  'versions.new_dialog.header': 'Nowa wersja',
  'versions.new_dialog.label_title': 'Wersja:',
  'versions.new_dialog.label_branch': 'Gałąź:',
  'versions.new_dialog.packages.header': 'Pakiety',
  'versions.new_dialog.packages.empty': 'Nie dodano pakietów.',
  'versions.new_dialog.packages.add': 'Dodaj pakiet',
  'versions.new_dialog.packages.add_existing': 'Dodaj wcześniej przesłany pakiet',
  'versions.new_dialog.packages.replace': 'Zastąp pakiet',
  'versions.new_dialog.packages.edit': 'Edytuj pakiet',
  'versions.new_dialog.ok': 'Utwórz wersję',
  'versions.manage': 'Zarządzaj wersją',
  'versions.rename': 'Zmień nazwę wersji',
  'versions.rename_dialog.header': 'Zmień nazwę wersji',
  'versions.rename_dialog.label': 'Nazwa wersji:',
  'versions.rename_dialog.ok': 'Zmień nazwę',
  'versions.edit_description': 'Edytuj opis wersji',
  'versions.edit_description_dialog.header': 'Edytuj opis wersji',
  'versions.edit_description_dialog.label': 'Opis wersji:',
  'versions.edit_description_dialog.ok': 'Zapisz opis',
  'versions.delete': 'Usuń wersję',
  'versions.delete_dialog.header': 'Usuń wersję',
  'versions.delete_dialog.message': (versionTitle) => <>Czy na pewno chcesz usunąć wersję {versionTitle}?</>,
  'versions.delete_dialog.ok': 'Usuń wersję',

  'versions.publish_dialog.header': 'Opublikuj wersję w gałęzi',
  'versions.publish_dialog.message': (versionTitle) => <>Wybierz gałąź, w której chcesz opublikować wersję {versionTitle}.</>,
  'versions.publish_dialog.no_branches': 'Brak gałęzi w projekcie.',
  'versions.publish_dialog.ok': 'Opublikuj wersję',

  'versions.publish_existing_dialog.header': 'Opublikuj wersję ponownie',
  'versions.publish_existing_dialog.message': 'Ostatnie wersje:',
  'versions.publish_existing_dialog.no_versions': 'Brak wersji w projekcie.',
  'versions.publish_existing_dialog.ok': 'Opublikuj wersję',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': 'Pakiet',
  'packages.download_zip': 'Pobierz jako ZIP',
  'packages.download_torrent': 'Pobierz torrent',
  'packages.total_size': (size) => <>Całkowity rozmiar: {size}</>,
  'packages.manage': 'Zarządzaj pakietem',
  'packages.rename': 'Zmień nazwę pakietu',
  'packages.rename_dialog.header': 'Zmień nazwę pakietu',
  'packages.rename_dialog.label': 'Nazwa pakietu:',
  'packages.rename_dialog.ok': 'Zmień nazwę',
  'packages.edit_tags': 'Edytuj tagi pakietu',
  'packages.edit_tags_dialog.header': 'Edytuj tagi pakietu',
  'packages.edit_tags_dialog.message': (packageTitle) => <>Określ tagi pakietu {packageTitle}:</>,
  'packages.edit_tags_dialog.ok': 'Zapisz tagi',
  'packages.entrypoint': (entrypoint) => <>Plik startowy: {entrypoint}</>,
  'packages.entrypoint.empty': 'Plik startowy nie jest ustawiony.',
  'packages.delete': 'Usuń pakiet',
  'packages.delete_dialog.header': 'Usuń pakiet',
  'packages.delete_dialog.message': (packageTitle) => <>Czy na pewno chcesz usunąć pakiet {packageTitle}? Pakiet zostanie usunięty ze wszystkich wersji, do których został dodany.</>,
  'packages.delete_dialog.ok': 'Usuń pakiet',

  'packages.new_dialog.header': 'Nowy pakiet',
  'packages.new_dialog.label_title': 'Tytuł:',
  'packages.new_dialog.title_placeholder': '(z tagów)',
  'packages.new_dialog.tags.header': 'Tagi',
  'packages.new_dialog.files.header': 'Pliki',
  'packages.new_dialog.total_size': (size, maximum) => <>Całkowity rozmiar: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(maksymalnie {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>Rozmiar nowych danych: {size}</>,
  'packages.new_dialog.checks.empty': 'Nie dodano plików.',
  'packages.new_dialog.checks.entrypoint.empty': 'Plik startowy nie jest ustawiony.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>Plik startowy {entrypoint} nie istnieje; być może zapomniałeś go dodać? Podaj istniejący plik startowy lub nie ustawiaj go wcale.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': 'Usuń plik startowy',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>Plik startowy ma rozszerzenie {fileExt}: sugerowany tag {tag}.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>Dodaj tag {tag}</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>Plik startowy ma rozszerzenie {fileExt}: dodaj tag {tag}, aby pakiet był grywalny w przeglądarce.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>Plik startowy ma rozszerzenie {fileExt}: czy to pomyłka? Zwykle nie jest to typ pliku, który można uruchomić.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>Plik startowy ma rozszerzenie {fileExt}: zaleca się dołączenie rzeczywistych plików zawartości zamiast pakowania ich do archiwum.</>,
  'packages.new_dialog.checks.entrypoint.executable': 'Plik startowy nie jest oznaczony jako wykonywalny',
  'packages.new_dialog.checks.entrypoint.executable.action': 'Oznacz jako wykonywalny',
  'packages.new_dialog.checks.single_root_dir': 'Zaleca się umieszczanie plików bezpośrednio w katalogu głównym, zamiast jednego podfolderu.',
  'packages.new_dialog.checks.single_root_dir.action': 'Zastąp folder jego zawartością',

  'packages.add_existing_dialog.header': 'Dodaj pakiet',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `Dodaj ${plural(packagesCount, `${packagesCount} pakiet`, `${packagesCount} pakiety`)}` : 'Nie wybrano pakietów',
  'packages.add_existing_dialog.message': 'Ostatnio przesłane pakiety:',
  'packages.add_existing_dialog.no_packages': 'Brak ostatnio przesłanych pakietów.',

  'packages.launch': 'Uruchom',

  'packages.install': 'Instaluj',
  'packages.install_dialog.header': 'Instaluj',
  'packages.install_dialog.workdir.label': 'Katalog roboczy:',
  'packages.install_dialog.workdir.value.new': '(utwórz nowy)',
  'packages.install_dialog.workspace.label': 'Utwórz folder w:',
  'packages.install_dialog.workspace.placeholder': '(wybierz folder główny)',
  'packages.install_dialog.ok': 'Instaluj',

  'packages.update': 'Aktualizuj',

  'packages.upload.status.existing': 'Z poprzedniej wersji',
  'packages.upload.status.queued': 'W kolejce',
  'packages.upload.status.packing': 'Pakowanie...',
  'packages.upload.status.creating': 'Tworzenie...',
  'packages.upload.status.create_retrying': 'Tworzenie nie powiodło się, oczekiwanie i ponawianie',
  'packages.upload.status.splitting': 'Dzielenie...',
  'packages.upload.status.uploading': 'Przesyłanie...',
  'packages.upload.status.finalizing': 'Finalizowanie...',
  'packages.upload.status.finalize_retrying': 'Finalizowanie nie powiodło się, oczekiwanie i ponawianie',
  'packages.upload.status.resolving': 'Rozwiązywanie poprawki...',
  'packages.upload.status.resolve_retrying': 'Rozwiązywanie poprawki nie powiodło się, oczekiwanie...',
  'packages.upload.status.done': 'Przesłano pomyślnie',
  'packages.upload.status.errored': 'Błąd',

  'packages.upload.part.status.queued': 'W kolejce',
  'packages.upload.part.status.hashing': 'Haszowanie',
  'packages.upload.part.status.upload_queued': 'Przesyłanie w kolejce',
  'packages.upload.part.status.uploading': 'Przesyłanie',
  'packages.upload.part.status.upload_retrying': 'Błąd, ponawianie przesyłania',
  'packages.upload.part.status.upload_finalizing': 'Finalizowanie przesyłania',
  'packages.upload.part.status.upload_errored': 'Błąd',
  'packages.upload.part.status.done': 'Przesłano',

  'packages.play': 'Graj w przeglądarce',
  'packages.play.reset': 'Resetuj',
  'packages.play.fullscreen': 'Pełny ekran',

  'deploy_sites.add_dialog.header': 'Dodaj witrynę wdrożeniową',
  'deploy_sites.add_dialog.message': (projectTitle) => <>Wybierz dane uwierzytelniające wdrożenia i wprowadź adres URL witryny, aby zapisać je jako witrynę wdrożeniową dla projektu {projectTitle}.</>,
  'deploy_sites.add_dialog.label_credential': 'Dane wdrożeniowe:',
  'deploy_sites.add_dialog.select_credential': 'Wybierz dane uwierzytelniające',
  'deploy_sites.add_dialog.select_credential.new': 'Dodaj nowe dane...',
  'deploy_sites.add_dialog.label_select_site': 'Wybierz witrynę:',
  'deploy_sites.add_dialog.select_credential_first': '(najpierw wybierz dane)',
  'deploy_sites.add_dialog.select_site': '(wybierz witrynę)',
  'deploy_sites.add_dialog.label_enter_site': 'Lub wpisz URL witryny:',
  'deploy_sites.add_dialog.ok': 'Dodaj witrynę',

  'deploy_to_site_dialog.header': 'Publikuj w witrynie',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>Wybierz witrynę, w której chcesz opublikować wersję {versionTitle} projektu {projectTitle}.</>,
  'deploy_to_site_dialog.label_site': 'Publikuj w witrynie:',
  'deploy_to_site_dialog.select_site': 'Wybierz witrynę',
  'deploy_to_site_dialog.select_site.new': 'Dodaj nową witrynę...',
  'deploy_to_site_dialog.packages.message.itch': <>Pakiety zostaną opublikowane na itch.io przy użyciu narzędzia <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a>. Nazwy kanałów pochodzą z tagów pakietów.</>,
  'deploy_to_site_dialog.deploy': 'Publikuj',
  'deploy_to_site_dialog.close': 'Zamknij',
  'deploy_to_site_dialog.error.no_packages': 'Brak pakietów do opublikowania.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>Nie można opublikować wielu pakietów w jednym kanale. Obecnie {plural(packagesCount, <>{packagesCountText} pakiet jest</>, <>{packagesCountText} pakiety są</>)} ustawione do publikacji w kanale {channel}.</>,
  'deploy_to_site_dialog.job.queued': 'W kolejce',
  'deploy_to_site_dialog.job.downloading': 'Pobieranie...',
  'deploy_to_site_dialog.job.unpacking': 'Rozpakowywanie...',
  'deploy_to_site_dialog.job.uploading': 'Publikowanie...',
  'deploy_to_site_dialog.job.succeeded': 'Sukces',
  'deploy_to_site_dialog.job.errored': 'Błąd',

  'store': 'Sklep',
  'store.hint': 'Projekty publiczne',
  'store.project.hint': 'Strona projektu w sklepie',
  'store.project.owner': 'Deweloper',
  'store.project.description': 'Opis',
  'store.project.star': 'Dodaj gwiazdkę',
  'store.project.starred': 'Z gwiazdką',
  'store.project.content': 'Zawartość',
  'store.project.content.warning': 'Zawartość została dostarczona przez zewnętrznego dewelopera.',
  'store.project.branch_version': (branchTitle, versionTitle) => <>Gałąź {branchTitle}: wersja {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>Opublikowano: {branchVersionPublished}</>,

  'me': 'Profil',
  'me.hint': 'Ustawienia profilu i połączone dane uwierzytelniające',
  'me.rename': 'Zmień nazwę profilu',
  'me.rename_dialog.header': 'Zmień nazwę profilu',
  'me.rename_dialog.label_title': 'Nazwa:',
  'me.rename_dialog.ok': 'Zmień nazwę',
  'me.credentials': 'Dane uwierzytelniające',
  'me.credentials.hint.auth_allowed': 'Dowolne z tych danych mogą być użyte do zalogowania się na to konto.',
  'me.credentials.hint.auth_disallowed': 'Te dane są powiązane z Twoim kontem, ale nie można ich użyć do logowania.',
  'me.credentials.empty': 'Brak danych uwierzytelniających.',
  'me.credentials.empty.auth_allowed.warning': 'Możesz stracić dostęp do konta! Nie masz powiązanych żadnych danych do logowania. Jak najszybciej powiąż dane, którymi możesz się zalogować.',
  'me.credentials.profile_picture.alt': (provider) => `Zdjęcie profilowe ${dict[`auth.provider.${provider}`]}`,
  'me.credentials.created': (created) => <>dodano {created}</>,
  'me.credentials.last_used': (lastUsed) => <>ostatnio użyto {lastUsed}</>,
  'me.credential.unlink': 'Odłącz',
  'me.credential.allow_auth': 'Zezwól na logowanie',
  'me.credential.disallow_auth': 'Zablokuj logowanie',
  'me.credential.display_publicly': 'Wyświetlaj publicznie',
  'me.credential.dont_display_publicly': 'Nie wyświetlaj publicznie',
  'me.credential.link': 'Powiąż dane',
  'me.credential.link_dialog.header': 'Powiąż dane uwierzytelniające',
  'me.credential.link_dialog.message': 'Wybierz dostawcę konta do powiązania.',
  'me.credential.unlink_dialog.header': 'Odłącz dane uwierzytelniające',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>Czy na pewno chcesz odłączyć konto {credentialProvider} ({credentialTitle}) od swojego konta Kavykhi.Cloud?</>,
  'me.credential.unlink_dialog.ok': 'Odłącz dane',
  'me.sessions': 'Sesje',
  'me.sessions.hint': 'To jest lista Twoich aktywnych sesji, w tym obecnej przeglądarki.',
  'me.sessions.started': (started) => <>rozpoczęto <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>aktywność <span class="value">{lastAuth}</span></>,
  'me.sessions.current': 'Bieżąca sesja',
  'me.sessions.empty': 'Brak sesji.',
  'me.sessions.delete': 'Zakończ',
  'me.sessions.delete_dialog.header': 'Zakończ sesję',
  'me.sessions.delete_dialog.message': 'Czy na pewno chcesz zakończyć tę sesję?',
  'me.sessions.delete_dialog.ok': 'Zakończ sesję',
  'me.api_tokens': 'Tokeny API',
  'me.api_tokens.hint': 'Tutaj możesz wygenerować tokeny API do automatyzacji.',
  'me.api_tokens.started': (started) => <>utworzono <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>wygasa <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': 'brak wygasania',
  'me.api_tokens.empty': 'Brak tokenów API.',
  'me.api_tokens.create': 'Generuj token API',
  'me.api_tokens.create_dialog.header': 'Generuj token API',
  'me.api_tokens.create_dialog.message': 'Wygenerowany token API:',
  'me.api_tokens.create_dialog.note': 'Token nie zostanie pokazany ponownie, zapisz go w bezpiecznym miejscu.',
  'me.api_tokens.delete': 'Usuń',
  'me.api_tokens.delete_dialog.header': 'Usuń token API',
  'me.api_tokens.delete_dialog.message': 'Czy na pewno chcesz usunąć ten token?',
  'me.api_tokens.delete_dialog.ok': 'Usuń token API',
  'me.deploy_credentials': 'Dane wdrożeniowe',
  'me.deploy_credentials.hint': 'Tutaj możesz dodać dane uwierzytelniające do platform wydawniczych.',
  'me.deploy_credentials.empty': 'Nie dodano danych wdrożeniowych.',
  'me.deploy_credential.add': 'Dodaj dane wdrożeniowe',
  'me.deploy_credential.add_dialog.header': 'Dodaj dane wdrożeniowe',
  'me.deploy_credential.add_dialog.label_site': 'Witryna:',
  'me.deploy_credential.add_dialog.label_title': 'Notatka:',
  'me.deploy_credential.add_dialog.label_key': 'Klucz:',
  'me.deploy_credential.add_dialog.default_title': (date) => `Klucz ${date}`,
  'me.deploy_credential.add_dialog.ok': 'Dodaj dane',
  'me.deploy_credential.add_dialog.hint.itch': <>Aby wygenerować klucz API itch.io, przejdź do <a href="https://itch.io/user/settings/api-keys" target="_blank">ustawień profilu</a> na itch.io. Możesz użyć istniejącego klucza ze źródłem „web” lub „wharf”. Klucz ze źródłem „Kavykhi.Cloud” nie zadziała.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>Obecnie nie obsługujemy dodawania danych dla {credentialProvider}.</>,
  'me.deploy_credential.delete': 'Usuń',
  'me.deploy_credential.delete_dialog.header': 'Usuń dane wdrożeniowe',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>Czy na pewno chcesz usunąć dane {credentialTitle} dla {credentialProvider}? Wszystkie witryny wdrożeniowe skonfigurowane z tymi danymi zostaną również usunięte z projektu.</>,
  'me.deploy_credential.delete_dialog.ok': 'Usuń dane',
  'me.public_profile': 'Profil publiczny',
  'me.public_profile.public_credentials': 'Dane publiczne',
  'me.public_profile.public_credentials.hint': 'Wybierz dane uwierzytelniające do wyświetlania publicznego.',
  'me.manage': 'Zarządzaj kontem',
  'me.delete': 'Usuń konto',
  'me.delete.dialog.header': 'Usuń konto',
  'me.delete.dialog.message': (userTitle) => <>Czy na pewno chcesz bezpowrotnie usunąć swoje konto Kavykhi.Cloud {userTitle}?</>,
  'me.delete.dialog.ok': 'Usuń konto',

  'invite': 'Zaproszenie',
  'invite.hint': 'Zaproszenie do projektu',
  'invite.message.already_member': (projectTitle) => <>Jesteś już członkiem projektu {projectTitle}.</>,
  'invite.message.join': (projectTitle) => <>Zostałeś zaproszony do projektu {projectTitle}.</>,
  'invite.join': 'Dołącz do projektu',

  'local': 'Lokalna zawartość',
  'local.hint': 'Lokalnie zainstalowana zawartość',
  'local.workdirs': 'Zainstalowane pakiety',
  'local.workdirs.empty': 'Brak zainstalowanych pakietów.',
  'local.workdir.action.launch': 'Uruchom',
  'local.workdir.action.repair': 'Napraw',
  'local.workdir.action.delete': 'Odinstaluj',
  'local.workdir.delete_dialog.header': 'Odinstaluj pakiet',
  'local.workdir.delete_dialog.message': (packageTitle) => <>Czy na pewno chcesz odinstalować pakiet {packageTitle} ze swojego urządzenia?</>,
  'local.workdir.delete_dialog.ok': 'Odinstaluj',
  'local.workspaces': 'Foldery główne',
  'local.app_not_detected.message': 'Nie wykryto lokalnej aplikacji Kavykhi.Cloud. Pobierz ją i zainstaluj, korzystając z jednego z poniższych linków. Jeśli jest już zainstalowana, upewnij się, że działa.',

  'local_app.detected': 'Lokalna zawartość',

  'error_dialog.header': 'Błąd',
  'error_dialog.messageFunc': (e) => `Błąd: ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': 'Wybierz pliki',
  'upload_box.choose_directories': 'Wybierz foldery',
  'upload_box.add.progress_dialog.header': 'Dodawanie plików',
  'upload_box.add.progress_dialog.message': 'Przetwarzanie plików...',
  'upload_box.delete': (itemsCount) => `Usuń ${plural(itemsCount, `${itemsCount} element`, `${itemsCount} elementy`)}`,
  'upload_box.start_upload': 'Rozpocznij przesyłanie',
  'upload_box.drop_area.message': 'Przeciągnij pliki i foldery tutaj',
  'upload_box.drop_area.box_dropping_message': 'Upuść tutaj, aby umieścić w katalogu głównym',
  'upload_box.entry.explode_folder': 'Zastąp folder jego zawartością',
  'upload_box.entry.set_entrypoint': 'Ustaw plik startowy',
  'upload_box.entry.mark_executable': 'Oznacz jako wykonywalny',
  'upload_box.entry.unmark_executable': 'Cofnij ozn. wykonywalnego',
  'upload_box.entry.remove': 'Usuń',

  'package.tags.empty': '(brak tagów)',
  'package.tag.os': 'System',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'Architektura',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'Bity',
  'package.tag.bits:64': '64-bit',
  'package.tag.bits:32': '32-bit',
  'package.tag.packaging': 'Pakowanie',
  'package.tag.packaging:installer': 'Instalator',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'Komponent',
  'package.tag.component:client': 'Klient',
  'package.tag.component:server': 'Serwer',
  'package.tag.runtime': 'Środowisko',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Dystrybucja Linux',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'Dokumentacja',
  'docs.page_no_language': 'Niedostępne w tym języku',
  'docs.page_no_language.message': 'Inne wersje językowe tego dokumentu:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'Zgłoś zawartość',
  'report_content.dialog.header': 'Zgłoś zawartość',
  'report_content.dialog.link': 'Wyślij zgłoszenie e-mailem',
  'report_content.dialog.message': (email, link) => <>Kliknij link, aby wysłać zgłoszenie:<br /><br />{link}<br /><br />Lub napisz do nas ręcznie na adres {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
